// mobile menu
function sandwichEventClick(event) {
  const menu_shell = document.querySelector(".navigation__mobile");
  const is_active_menu = menu_shell.classList.contains(
    "navigation__mobile--active"
  );
  if (is_active_menu) {
    getHideMenu();
  } else {
    getDisplayMenu();
  }
}

function getDisplayMenu() {
  // document.querySelector("body").style.overflow = "hidden";
  // document.querySelector('body').style.touchAction = 'auto';
  document.querySelector("body").classList.add("vmenu-hidden");
  document.querySelector("html").classList.add("vmenu-hidden");

  const menu_shell = document.querySelector(".navigation__mobile");
  menu_shell.classList.add("navigation__mobile--active");

  const sandwich = document.querySelector(".navigation__hamburger");
  sandwich.classList.add("navigation__hamburger--active");

  document.body.classList.add("frozen");

  const items = document.querySelectorAll(
    ".navigation__mobile .mobile-menu li"
  );
  items.forEach((li, ind) => {
    setTimeout(() => {
      li.classList.add("display");
    }, ind * 40);
  });
}

function getHideMenu() {
  // document.querySelector("body").style.overflow = "auto";
  // document.querySelector('body').style.touchAction = 'auto';
  document.querySelector("body").classList.remove("vmenu-hidden");
  document.querySelector("html").classList.remove("vmenu-hidden");

  const menu_shell = document.querySelector(".navigation__mobile--active");
  menu_shell.classList.remove("navigation__mobile--active");

  const sandwich = document.querySelector(".navigation__hamburger--active");
  sandwich.classList.remove("navigation__hamburger--active");

  document.body.classList.remove("frozen");

  const items = document.querySelectorAll(
    ".navigation__mobile .mobile-menu li"
  );
  items.forEach((li, ind) => {
    setTimeout(() => {
      li.classList.remove("display");
    }, ind * 40);
  });
}

document.addEventListener("DOMContentLoaded", (event) => {
  const sandwich = document.querySelector(".navigation__hamburger");
  sandwich.addEventListener("click", (event) => {
    sandwichEventClick(event);
  });

  const sandwichClose = document.querySelector(".navigation__mobile-close");
  sandwichClose.addEventListener("click", (event) => {
    sandwichEventClick(event);
  });

  // close after menu item click
  let menuItemClick = document.querySelectorAll(
    ".navigation__mobile .menu-item:not(.menu-item-has-children) a"
  );
  for (let i = 0; i < menuItemClick.length; i++) {
    menuItemClick[i].addEventListener("click", (event) => {
      sandwichEventClick(event);
    });
  }
});

let hasChild = document.querySelectorAll(".menu-item-has-children > svg");
for (let i = 0; i < hasChild.length; i++) {
  hasChild[i].addEventListener("click", function (event) {
    event.preventDefault();
  });
}

let menuHasChildren = document.querySelectorAll(
  ".navigation__mobile .menu-item-has-children"
);
if (menuHasChildren.length !== 0) {
  for (let i = 0; i < menuHasChildren.length; i++) {
    menuHasChildren[i].addEventListener("click", function (e) {
      menuHasChildren[i].classList.toggle("menu-item-has-children--active");
    });
  }
}



let carretsMobile = document.querySelectorAll(
  ".mobile-navigation .menu-item-has-children"
);
[].forEach.call(carretsMobile, function (addCarretsMobile) {
  addCarretsMobile.innerHTML +=
    '<svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7M7 7L6.71429 6.71429M7 7L1 13" stroke-width="2" stroke-linecap="round"/></svg>';
});